import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  timeout: 60000,
});

export default api;

export const FIELD_KEYS = ["code", "name", "price", "quantity", "producer"];
export const FIELD_LABELS = {
  code: "Код ЕГК",
  name: "Название",
  price: "Цена",
  quantity: "Количество",
  producer: "Производитель",
};
